import styled from 'styled-components';
import { flexCenter, pxToRem } from 'Styles/utils/utils';
import { DESKTOP_WIDTH } from 'Styles/variables/sizes';

export const BackButton = styled.button`
  font-size: ${({ theme: { fontSizes } }) => pxToRem(fontSizes.s)};
  font-weight: bold;
  line-height: 1.43;
  cursor: pointer;
  padding: 0;
  display: none;
  z-index: 1;
  &.hide {
    opacity: 0;
  }
  svg {
    transform: rotate(180deg);
    margin-right: ${pxToRem(5)};
    transition: transform 0.3s ease-in-out 0s;
  }
  &.is-open {
    svg {
      transform: rotate(0);
    }
  }
  @media screen and (max-width: ${DESKTOP_WIDTH}) {
    ${flexCenter}
  }
`;
